<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      fixed
      app
      width="275"
      class="drawer-padding"
      mobile-break-point="960"
      style="background-color: #fafafa"
    >
      <setappSideBar v-if="service == 'setapp'" />
      <storeSidebar v-if="store_name != null" />
      <weserveSideBar v-if="service == 'weserve'" />
      <posSidebar v-if="service == 'storeandproduct'" />
      <messengerSideBar v-if="service == 'messenger'" />
      <ordersideBar
        @setFetchingOrder="fetching_order = $event"
        v-if="
          'order' in permission &&
          Object.keys(permission.order).length > 0 &&
          $route.path.includes('orderweserve')
        "
      />
      <orderDineInSideBar
        v-if="
          'dine_in_management' in permission.main_menu &&
          'order_list' in permission.main_menu.dine_in_management &&
          Object.keys(permission.main_menu.dine_in_management.order_list)
            .length > 0 &&
          $route.path.includes('maindinein/order')
        "
      />

      <orderWesmartSideBar
        @setFetchingOrder="fetching_order = $event"
        v-if="
          'order_wesmart' in permission &&
          Object.keys(permission.order_wesmart).length > 0 &&
          $route.path.includes('orderwesmart')
        "
      />
      <riderSideBar v-if="service == 'rider'" />
      <reportSideBar v-if="service == 'report'" />
      <merchantCoreSidebar v-if="isShowMerchantCore" />
      <dineinCoreSidebar v-if="isShowDineInCore" />
      <mainReportSidebar v-if="$route.path.includes('reportdashboard')" />
      <commissionsidebar
        v-if="
          $route.path == '/weserve_admin_login/-/manager-manage' ||
          $route.path == '/weserve_admin_login/-/CommissionArea' ||
          $route.name == 'bankList' ||
          $route.name == 'bankApprove' ||
          $route.name == 'moneymanage' ||
          $route.name == 'Withdraw'
        "
      />
      <businesssidebar
        v-if="
          $route.name == 'businesslist' ||
          $route.name == 'businesstable' ||
          $route.name == 'tablelog' ||
          $route.name == 'businessid' ||
          $route.name == 'businessclient' ||
          $route.name == 'businessclient_id' ||
          $route.name == 'minitorinvoice'
        "
      />
      <hotelServiceSideBar
        v-if="$route.name == 'hotelList'"
      ></hotelServiceSideBar>
      <sideBar />
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left color="primary" style="z-index: 10">
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="hidden-xs-only">
        <img
          @click="toHomePage()"
          src="./../assets/back-office/logo.png"
          alt="weserve"
          class="logo-brand hidden-xs-only"
        />
        <img
          @click="toHomePage()"
          src="./../assets/back-office/logo1.png"
          alt="weserve"
          class="logo1-brand hidden-xs-only"
        />
        <!-- <img src="./../assets/back-office/phuket.png" alt="logo phuket" width="120px" style="position:absolute;top:10px;" v-if="province == 'phuket'">
        <img src="./../assets/back-office/trang.png" alt="logo trang" width="120px" style="position:absolute;top:10px;" v-if="province == 'trang'">-->

        <span class="text-select-province">{{
          province_state != null && province_state != "-"
            ? province_state.charAt(0).toUpperCase() + province_state.slice(1)
            : null
        }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-progress-circular
        :size="55"
        color="black"
        :indeterminate="loading"
        style="right:20px; position:absolute;"
        class="hidden-xs-only"
      ></v-progress-circular>-->
      <v-spacer></v-spacer>
      <v-flex style="color: red" v-if="disconnected == true">
        <h1>Disconnect from server...</h1>
      </v-flex>
      <v-toolbar-items>
        <v-btn flat :to="'/weserve_admin_login/select/'">
          <v-icon>view_agenda</v-icon>
          <span class="toolbar-btn">&nbsp; Home</span>
        </v-btn>
        <v-menu transition="slide-y-transition" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              flat
              v-on="on"
              v-if="Object.keys(permission.order).length > 0"
            >
              <v-icon style="font-size: 32px">expand_more</v-icon>
              <span class="toolbar-btn">&nbsp; order dashboard</span>
            </v-btn>
          </template>
          <v-list>
            <div style="padding: 10px 5px">
              <div
                style="
                  width: 100%;
                  height: 14px;
                  border-bottom: 1.5px solid grey;
                  text-align: center;
                "
              >
                <span
                  style="
                    font-weight: bold;
                    color: grey;
                    font-size: 14px;
                    padding: 0 10px;
                    background-color: white;
                    font-family: 'GoldenPlains';
                  "
                >
                  Select Province
                </span>
              </div>
            </div>
            <v-list-tile
              v-if="
                ('order' in permission &&
                  Object.keys(permission.order).length > 0 &&
                  province_state == null) ||
                province_state == '-'
              "
              @click="$router.push({ path: '/weserve_admin_login/select/' })"
            >
              <v-list-tile-title
                style="display: flex; align-items: center; font-size: 16px"
              >
                <v-icon class="mr-1">dashboard</v-icon>Food &
                Messenger</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile
              v-else-if="
                'order' in permission &&
                Object.keys(permission.order).length > 0
              "
              :to="
                '/weserve_admin_login/orderweserve/' +
                province_state +
                '/orderlist/ordermade'
              "
            >
              <v-list-tile-title
                style="display: flex; align-items: center; font-size: 16px"
              >
                <v-icon
                  class="mr-1"
                  :color="$route.path.includes('orderweserve') ? 'primary' : ''"
                  >dashboard</v-icon
                >Food & Messenger</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile
              v-if="
                'order_wesmart' in permission &&
                Object.keys(permission.order_wesmart).length > 0 &&
                (province_state == null || province_state == '-')
              "
              @click="$router.push({ path: '/weserve_admin_login/select/' })"
            >
              <v-list-tile-title>
                <v-icon class="mr-1">dashboard</v-icon
                >WESMART</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile
              :disabled="
                province_state == null || province_state == '-' ? true : false
              "
              v-else-if="
                'order_wesmart' in permission &&
                Object.keys(permission.order_wesmart).length > 0
              "
              :to="
                '/weserve_admin_login/orderwesmart/' +
                province_state +
                '/orderlist/ordermade'
              "
            >
              <v-list-tile-title>
                <v-icon
                  :disabled="
                    province_state == null || province_state == '-'
                      ? true
                      : false
                  "
                  class="mr-1"
                  :color="$route.path.includes('orderwesmart') ? 'primary' : ''"
                  >dashboard</v-icon
                >WESMART</v-list-tile-title
              >
            </v-list-tile>
            <div style="padding: 10px 5px">
              <div
                style="
                  width: 100%;
                  height: 14px;
                  border-bottom: 1.5px solid grey;
                  text-align: center;
                "
              >
                <span
                  style="
                    font-weight: bold;
                    color: grey;
                    font-size: 14px;
                    padding: 0 10px;
                    background-color: white;
                    font-family: 'GoldenPlains';
                  "
                >
                  All Province
                </span>
              </div>
            </div>
            <v-list-tile
              v-if="
                'dine_in_management' in permission.main_menu &&
                'order_list' in permission.main_menu.dine_in_management &&
                Object.keys(permission.main_menu.dine_in_management.order_list)
                  .length > 0
              "
              :to="'/weserve_admin_login/-/maindinein/order'"
            >
              <v-list-tile-title>
                <v-icon
                  class="mr-1"
                  :color="
                    $route.path.includes('maindinein/order') ? 'primary' : ''
                  "
                  >dashboard</v-icon
                >Dine in</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn
          flat
          :to="'/weserve_admin_login/control/' + province_state"
          :disabled="
            province_state == null || province_state == '-' ? true : false
          "
        >
          <v-icon>ballot</v-icon>
          <span class="toolbar-btn">&nbsp; control</span>
        </v-btn>
      </v-toolbar-items>

      <div class="text-xs-center avatar-padding" v-if="isAuth">
        <v-menu v-model="menu" offset-y>
          <v-btn slot="activator" color="#333" dark icon>
            <v-icon>person</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon medium>person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  permission.permission_name ? permission.permission_name : role
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ user_name }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider style="background-color: #d2d2d2" />
          <v-list>
            <v-btn
              flat
              block
              small
              @click="$store.dispatch('logout')"
              v-if="isAuth"
              >Log out</v-btn
            >
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height class="pt-2 pl-2 pr-3">
        <v-layout justify-center>
          <v-flex style="margin-top: 5px">
            <!-- <v-breadcrumbs :items="recentRoutePath" style="padding:0 0 5px 0;">
            <v-icon slot="divider">chevron_right</v-icon>
            </v-breadcrumbs>-->

            <transition name="fade" mode="out-in">
              <router-view
                :fetching_order="fetching_order"
                @showSlideBar="weserveSlideBar = true"
              ></router-view>
            </transition>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app fixed class="pa-3">
      <v-breadcrumbs
        :items="recentRoutePath"
        divider=">"
        style="padding: 5px 0"
      >
        <v-breadcrumbs-item
          slot="item"
          slot-scope="{ item }"
          exact
          @click.native="$router.push({ path: item.href })"
          :disabled="item.disabled"
          >{{ item.text }}</v-breadcrumbs-item
        >
      </v-breadcrumbs>
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }} Powered by WESERVE</div>
    </v-footer>
  </v-app>
</template>

<script>
import setappSideBar from "@/components/back-office/SetAppSideBar";
import messengerSideBar from "@/components/back-office/MessengerSideBar";
import riderSideBar from "./../components/back-office/RiderSideBar";
import sideBar from "./../components/back-office/MainSideBar";
import weserveSideBar from "./../components/back-office/WeserveSideBar";
import posSidebar from "./../components/back-office/PosSideBar.vue";
import storeSidebar from "@/components/back-office/StoreSideBar.vue";
import ordersideBar from "./../components/back-office/OrderSideBar.vue";
import reportSideBar from "./../components/back-office/ReportSideBar";
import orderDineInSideBar from "./../components/back-office/OrderDineInSideBar.vue";
import merchantCoreSidebar from "./../components/back-office/MerchantCoreSidebar.vue";
import mainReportSidebar from "./../components/back-office/MainReportSidebar.vue";
import orderWesmartSideBar from "./../components/back-office/OrderWesmartSideBar.vue";
import dineinCoreSidebar from "./../components/back-office/DineInCoreSidebar.vue";
import commissionsidebar from "./../components/back-office/CommissionTopbar.vue";
import businesssidebar from "./../components/back-office/BusinessSidebar.vue";
import hotelServiceSideBar from "./../components/back-office/HotelServiceSidebar.vue";
import { mapState, mapGetters } from "vuex";

export default {
  props: ["province", "store_id"],
  data() {
    return {
      fetching_order: false,
      weserveSlideBar: false,
      menu: "",
      interval_order: "",
      drawer: true,
      props: {
        source: String,
      },
    };
  },
  components: {
    merchantCoreSidebar,
    setappSideBar,
    messengerSideBar,
    riderSideBar,
    sideBar,
    weserveSideBar,
    posSidebar,
    storeSidebar,
    ordersideBar,
    mainReportSidebar,
    reportSideBar,
    orderWesmartSideBar,
    dineinCoreSidebar,
    commissionsidebar,
    orderDineInSideBar,
    businesssidebar,
    hotelServiceSideBar,
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      province_state: (state) => state.backOffice.province,
      disconnected: (state) => state.disconnect,
      store_name: (state) => state.storeBack.store_name,
      service: (state) => state.backOffice.service,
      role: (state) => state.role,
      recentRoutePath: (state) => state.backOffice.recentRoutePath,
      loading: (state) => state.backOffice.loading,
      user_name: (state) => state.user_name,
    }),
    ...mapGetters({
      isAuth: "isAuth",
    }),
    isShowMerchantCore() {
      return (
        this.$route.path.split("/").length > 0 &&
        this.$route.path.split("/")[3] == "mainmerchant"
      );
    },
    isShowDineInCore() {
      return (
        this.$route.path.split("/").length > 0 &&
        this.$route.path.split("/")[3] == "maindinein"
      );
    },
  },
  methods: {
    toHomePage() {
      this.$router.push({ path: "/weserve_admin_login" });
    },
  },
  beforeDestroy() {
    this.$store.dispatch("backOffice/selectProvinceParam", null);
  },
  async mounted() {},
  destroyed() {
    clearInterval(this.interval_order);
  },
};
</script>

<style scoped></style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.v-breadcrumbs__item {
  color: black;
}

.theme--light.v-pagination .v-pagination__item--active {
  color: black;
}

.v-navigation-drawer__border {
  display: none;
}

.drawer-padding {
  padding: 1rem 0 1rem 0.9rem;
}

.drawer-padding::-webkit-scrollbar {
  display: none;
}

.avatar-padding {
  padding-right: 0;
}

.text-select-province {
  font-family: "GoldenPlains";
  font-size: 2.5rem;
  position: absolute;
  top: 5px;
  padding-left: 10px;
}

.logo-brand {
  padding-top: 10px;
  width: 200px;
  cursor: pointer;
}
.logo1-brand {
  padding-top: 10px;
  width: 40px;
  display: none;
  cursor: pointer;
}

@media screen and (max-width: 957px) {
  .text-select-province {
    font-size: 2rem;
    margin-top: 0px;
  }
  .logo-brand {
    display: none;
  }
  .logo1-brand {
    width: 40px;
    display: unset;
  }
  .avatar-padding {
    padding-right: 8px;
  }
  .drawer-padding {
    padding: 4.5rem 0 1rem 0.9rem;
  }
}
@media screen and (max-width: 600px) {
  .toolbar-btn {
    display: none;
  }
  .logo-brand {
    display: none;
  }
}
@media screen and (max-width: 520px) {
  .logo-brand {
    display: none;
    /* width: 200px; */
  }
  .text-select-province {
    display: none;
    /* font-size: 2rem;
    margin-top: 4px;
    left: 55px; */
  }
}
</style>
